import React from 'react';
import { useParams } from 'react-router-dom';

// Placeholder component for viewing a single chat history
const ChatView = () => {
  const { sessionId } = useParams();

  return (
    <div className="space-y-6">
      <div className="bg-white rounded-lg shadow p-6">
        <h1 className="text-3xl font-bold text-gray-800">Chat Session</h1>
        <p className="text-gray-500 mt-2">Session ID: {sessionId}</p>
        <p className="mt-4">This is a placeholder for viewing the full conversation and continuing the chat. This feature can be implemented next.</p>
      </div>
    </div>
  );
};

export default ChatView;
